import { render, staticRenderFns } from "./auth-by-code-card.vue?vue&type=template&id=f2bfdf14&scoped=true&"
import script from "./auth-by-code-card.vue?vue&type=script&lang=js&"
export * from "./auth-by-code-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bfdf14",
  null
  
)

export default component.exports